<template>
  <button @click="action()" :class="classObject" :disabled="!active">{{ text }}</button>
</template>

<script>
  export default {
    name: "ria-button",
    props: {
      text: String,
      fullwidth: {
        type: Boolean,
        default: false
      },
      outline: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: 'medium'
      },
      active: {
        type: Boolean,
        default: true
      },
      action: Function
    },
    computed: {
      classObject: function() {
        return {
          fullwidth: this.fullwidth,
          outline: this.outline,
          medium: this.size === 'medium',
          small: this.size === 'small',
          disabled: !this.active,
        }
      }
    },
  };
</script>

<style scoped>

  button {
    @apply text-base bg-secondary text-white rounded-full tracking-3xl;
  }

  .disabled {
    @apply cursor-not-allowed bg-grey-bg text-white border-none !important;
  }

  .fullwidth {
    @apply w-full;
  }

  .outline {
    @apply bg-white text-secondary border border-solid border-secondary;
  }

  .medium {
    @apply h-12 px-8;
  }

  .small {
    @apply h-10 px-3 tracking-base;
  }

</style>
